import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  display: -webkit-flex;
  flex-direction: column;

  width: 550px;
  height: 500px;
  border: '2px solid #000';
  background-color: #fefefe;
  border-radius: 0.3rem;
  position: relative;
  padding-bottom: 50px;

  @media(max-width: 960px){
    border-radius: 0;
    width: 100vw;
    height: 100vh;
    margin-top: 0;
    margin-left: 0;
  }
`;

export const Content = styled.div`
  display: -webkit-flex;
  flex-direction: column;

  overflow-y: scroll;

  padding-bottom: 20px;
`;

export const GroupSelection = styled.div`
  display: -webkit-flex;
  flex-direction: column;

  padding: 0 10px 0;

  h1 {
    font-size: 1.4rem;
  }
`;

export const ProductSelection = styled.div`
  display: -webkit-flex;
  flex-direction: column;

  padding: 0 10px 0;
  margin-top: 15px;

  h1 {
    font-size: 1.4rem;
  }

  & > div {
    display: -webkit-flex;
    flex-direction: column;

    margin-top: 10px;

    h2 {
      font-size: 1.2rem;
    }
  }
`;

export const SaveButtonSpace = styled.div`
  display: -webkit-flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 50px;

  position: absolute;
  bottom: 0;

  button {
    display: flex;
    align-items: center;
    padding: 13px 18px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.main};
    border: none;
    transition: background-color 0.2s ease;
    white-space: nowrap;
    
    font-family: 'Sora', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};

    &:hover {
      background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
    }
  }
`;